module.exports = __webpack_public_path__ + "media/images/favicon-f102241edb54568456bcbad7b65e4fb9.ico";